import { render, staticRenderFns } from "./DeleteProjectModal.vue?vue&type=template&id=068be31e&scoped=true&"
import script from "./DeleteProjectModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteProjectModal.vue?vue&type=style&index=0&id=068be31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068be31e",
  null
  
)

export default component.exports